// 困难生认定
export default [
    {
        path: '/difficultStudent',
        component: resolve => require(['@/pages/difficultStudent/difficultStudent.vue'], resolve),
        name: 'difficultStudent',
        meta: {
            title: '困难生认定'
        }
    },
    {
        path: '/difficultStudent/detail',
        component: resolve => require(['@/pages/difficultStudent/dsDetail.vue'], resolve),
        name: 'dsDetail',
        meta: {
            title: '困难生认定详情'
        }
    },
    {
        path: '/difficultStudent/detail/instructor',
        component: resolve => require(['@/pages/difficultStudent/dsDetail-instructor'], resolve),
        name: 'dsDetail',
        meta: {
            title: '困难生认定详情-辅导员'
        }
    },
    {
        path: '/dsAdministration',
        component: resolve => require(['@/pages/difficultStudent/dsAdministration.vue'], resolve),
        name: 'dsAdministration',
        meta: {
            title: '困难生管理'
        }
    },
    {
        path: '/dsStudentList',
        component: resolve => require(['@/pages/difficultStudent/ds-student-list'], resolve),
        name: 'dsStudentList',
        meta: {
            title: '查看名单'
        }
    },
    {
        path: '/scholarshipReading',
        component: resolve => require(['@/pages/difficultStudent/scholarshipReading'], resolve),
        name: 'scholarshipReading',
        meta: {
            title: '研究生国家助学金阅读管理'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/modules/difficultStudent.js